export const footerText = `© 1996 - ${new Date().getFullYear()} МОБИКОМ КОРПОРАЦИ`;
export const menuIconSize = 16;
export const pageLimit = 50;